import React from 'react';
import { HowToOrderItem } from './how-to-order-item';
import { HowToOrderSection } from './styles';
import { howToOrderItem } from './constants';

type Props = {
	openStoreSelectionModal: VoidFunction;
};

export const HowToOrder = ({ openStoreSelectionModal }: Props) => (
	<HowToOrderSection>
		<HowToOrderItem
			key={howToOrderItem.title}
			{...howToOrderItem}
			onClick={openStoreSelectionModal}
		/>
	</HowToOrderSection>
);
